import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Config from '../../../Config';
import { isMobile } from 'react-device-detect';
import Video from '../../Shared/Video/Video';

const GenericGuideVideo = (props) => {

    // const previewImage = (isMobile ? props.iContent.previewImageMobile?.expandedValue?.url : props.iContent.previewImageWeb?.expandedValue?.url);
    // const videoFile = Config.epiBaseUrl + props.iContent.videoFile?.expandedValue?.url;
    const videoUrl = props.iContent.videoUrl?.value;

    useEffect(() => {

    }, []);

    return (
        <div className='generic-guide-video'>
            <iframe src={videoUrl} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
            {/* <Video previewImage={previewImage ? Config.epiBaseUrl + previewImage : ''} videoFile={videoFile} /> */}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(GenericGuideVideo);